import { StatusPill as UiStatusPill } from '@ui-kit';
import type { StatusTone } from '@ui-kit';
import type { BizStatus } from '../types/catalog';

const STATUS_TONE: Record<BizStatus, StatusTone> = {
  DONE: 'success',
  WIP: 'warning',
  PLAN: 'neutral',
  TODO: 'neutral',
  PLANNED: 'neutral',
};

const STATUS_LABEL: Record<BizStatus, string> = {
  DONE: '완료',
  WIP: '진행중',
  PLAN: '계획',
  TODO: '미착수',
  PLANNED: '준비 중',
};

interface BizStatusPillProps {
  status: BizStatus;
  labelOverride?: string;
}

// R6-009 fix: 알 수 없는 status (백엔드가 enum 외 값을 보내는 경우) 도 빈 칸 대신 raw 값을 neutral 톤으로 노출.
export function BizStatusPill({ status, labelOverride }: BizStatusPillProps) {
  const tone = STATUS_TONE[status] ?? 'neutral';
  const label = labelOverride ?? STATUS_LABEL[status] ?? status;
  return <UiStatusPill tone={tone}>{label}</UiStatusPill>;
}
